import styled from 'styled-components';
import { Checkbox, Select as AntdSelect, SelectProps, Tag } from 'antd';
import {
  PRIMARY_TEXT_COLOUR,
  InputFontStyles,
  InputPadding,
  InputSize,
  SECONDARY_TEXT_COLOUR,
  PRIMARY_COLOUR,
} from '../../theme';
import { ChevronDown } from 'react-feather';
import { BaseOptionType } from 'rc-select/lib/Select';

const { Option } = AntdSelect;

const OptionText = styled.span`
  ${InputFontStyles};
  font-weight: 500;
`;
const StyledOption = styled(Option)`
  .anticon-check {
    color: ${PRIMARY_COLOUR} !important;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    background-color: ${PRIMARY_COLOUR};
    border-color: ${PRIMARY_COLOUR};
  }
`;

const Select = styled(AntdSelect)`
  && {
    width: 100%;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: black !important;
    box-shadow: none !important;
  }

  &&& .ant-select-selector {
    border-color: ${SECONDARY_TEXT_COLOUR} !important;
    cursor: pointer !important; // Force multiselect to pointer as well

    :hover,
    :focus,
    :focus-within {
      border-color: ${SECONDARY_TEXT_COLOUR};
      box-shadow: none;
    }

    ${InputFontStyles}
    ${InputPadding}
    ${InputSize};
    display: flex;
    align-items: center;
  }

  .ant-select-arrow {
    color: ${PRIMARY_TEXT_COLOUR};
    display: block;
    height: fit-content;
    width: fit-content;
    margin-top: -10px; // Combines with top:50% to center
    right: 22px;
    @media (max-width: 550px) {
      right: 12px;
    }
  }

  .ant-select-selection-placeholder {
    color: ${SECONDARY_TEXT_COLOUR};
    left: 22px;
  }

  .ant-select-selection-search {
    margin-inline-start: 0 !important;
  }
`;

const StyledTag = styled(Tag)`
  background: rgba(244, 132, 95, 0.2);
  padding: 4px 8px 4px 8px;
`;

interface SelectOption {
  name: string;
  value: string;
  label?: string;
}

interface SettingsSelectInputProps {
  options: SelectOption[];
  size: SelectProps<string>['size'];

  value?: string;
  showArrow?: SelectProps['showArrow'];
  optionLabelProp?: SelectProps['optionLabelProp'];
  mode?: SelectProps['mode'];
  placeholder?: SelectProps<string>['placeholder'];
  onSelect?: SelectProps<unknown, BaseOptionType>['onSelect'];
}

export const SelectInput = ({ options, ...props }: SettingsSelectInputProps) => (
  <Select
    suffixIcon={<ChevronDown size={20} />}
    tagRender={(props) => {
      return <StyledTag {...props}>{props?.label}</StyledTag>;
    }}
    maxTagCount="responsive"
    menuItemSelectedIcon={props.mode && ['multiple', 'tags'].includes(props.mode) && <StyledCheckbox checked />}
    {...props}
  >
    {options.map((option) => (
      <StyledOption key={option.value} value={option.value} label={option.label ?? option.name}>
        <OptionText>{option.name}</OptionText>
      </StyledOption>
    ))}
  </Select>
);
